// Fired on window by the Structure/Piping modules after a successful save,
// with `detail.projectId`, so an open EMS tree (useEmsProjectsTreeData) can
// refresh that WBS's Estimation revisions. Kept in its own module so the
// modules don't pull in the tree's data hook and its API imports.
export const PROJECT_SAVED_EVENT = "ems-tree:project-saved";

export const notifyProjectSaved = (projectId) => {
  if (projectId == null || projectId === "") return;
  window.dispatchEvent(
    new CustomEvent(PROJECT_SAVED_EVENT, { detail: { projectId } }),
  );
};
